import React, { Fragment, ReactElement } from 'react'
import i18n from 'live/services/i18n'

import { Flex, Icon, Title } from '../../../common/styles/global_styles'
import AddLookupButton from './AddLookupButton'
import type { LookupListDataModel } from '../../../common/types/utilities'

import LookupSelect from './LookupSelect'
import { Entries, Lookup } from '../../../common/types/api/LiveLookupResponse'

import { getLookupData, removeLookupData } from './helper'
import styled from 'styled-components'

interface LookupListProps {
    lookupData?: LookupListDataModel
    getLookup: () => Promise<Lookup[]>
    getLookupValues: (lookup: string) => Promise<Entries[]>
    handleLookup: (lookups: LookupListDataModel) => void
    editMode: boolean
}

const LookupList = ({
    handleLookup,
    lookupData = {},
    getLookup,
    getLookupValues,
    editMode
}: LookupListProps): ReactElement => {
    return (
        <LookupListContainer className="lookupList">
            <div className="lookupList--header">
                <div className={'lookupList--header__lookup'}>
                    <Title>{'Lookup'}</Title>
                </div>
                <div className={'lookupList--header__possibleValues'}>
                    <Title>{i18n('Possible Values')}</Title>
                </div>
            </div>
            <div className={'lookupList--ItemsContainer'}>
                {Object.entries(getLookupData(lookupData)).map(([lookupName, lookupValue], index) => {
                    return (
                        <Fragment key={index}>
                            <Flex direction={'row'} fillParent={true} justifyContent={'center'}>
                                <LookupSelect
                                    editMode={editMode}
                                    getLookup={getLookup}
                                    getLookupValues={getLookupValues}
                                    onChange={(key, values) => {
                                        if (key === lookupName) {
                                            // atualiza a mesma lookup
                                            handleLookup({
                                                ...lookupData,
                                                [key]: values
                                            })
                                        }

                                        if (!lookupData[key]) {
                                            handleLookup({
                                                ...removeLookupData(lookupName, lookupData),
                                                [key]: values
                                            })
                                        }
                                    }}
                                    lookupName={lookupName}
                                    lookupValues={lookupValue}
                                />
                                <TrashButton
                                    editMode={editMode}
                                    onClick={
                                        editMode
                                            ? () => handleLookup(removeLookupData(lookupName, lookupData))
                                            : () => console.log('you are not on edit mode')
                                    }
                                >
                                    <Icon className={'far fa-trash-alt trash_button'} />
                                </TrashButton>
                            </Flex>
                        </Fragment>
                    )
                })}
            </div>
            <AddLookupButton
                editMode={editMode}
                label={i18n('Add Lookup')}
                disabled={!!getLookupData(lookupData)['']}
                onClick={
                    editMode
                        ? () => {
                              handleLookup({
                                  ...lookupData,
                                  '': []
                              })
                          }
                        : () => console.log('you are not on edit mode')
                }
            />
        </LookupListContainer>
    )
}

export type { LookupListProps }
export default LookupList

const LookupListContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
    width: 100%;
    .lookupList {
        &--header {
            display: flex;
            justify-content: flex-start;
            height: 100%;
            width: 100%;
            &__lookup,
            &__possibleValues {
                border-top-left-radius: 0px;
                border-top-right-radius: 0px;
                background-clip: padding-box;
                border: 1px solid ${({ theme }) => theme['gray-500']};
                background: white;
                box-sizing: border-box;
                width: 50%;
                height: 28px;
                text-align: left;
                padding-left: 1%;
                padding-top: 5px;
                margin: 0%;
                font-size: 13px;
            }
            &__lookup {
                border-top-left-radius: 3px;
                width: 48.1%;
                border-right: none;
            }
            &__possibleValues {
                border-top-right-radius: 3px;
                width: 51.9%;
            }
        }
        &--ItemsContainer {
            display: flex;
            flex-direction: column;
            height: 100%;
        }
    }
`

interface TrashButonProps {
    editMode: boolean
}
const TrashButton = styled.button<TrashButonProps>`
    border: 1px solid ${({ theme }) => theme['gray-500']};
    min-height: 50px;
    height: auto;
    width: 3.9%;
    background-color: ${({ theme }) => theme['gray-0']};
    border-top: none;

    &:hover {
        .trash_button {
            color: ${props => (props.editMode ? props.theme['blue-500'] : props.theme['gray-800'])};
        }
    }

    .trash_button {
        font-size: 10px !important;
        font-style: normal;
        font-weight: normal;
        align-items: center;

        color: ${props => (props.editMode ? props.theme['red-500'] : props.theme['gray-1000'])};
    }
`
